module.exports = __webpack_public_path__ + "static/media/05.93617f0f.png";